import { render } from "./form-presentation-layout.vue?vue&type=template&id=0873f6d5&scoped=true&ts=true"
import script from "./form-presentation-layout.vue?vue&type=script&lang=ts"
export * from "./form-presentation-layout.vue?vue&type=script&lang=ts"

import "./form-presentation-layout.vue?vue&type=style&index=0&id=0873f6d5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0873f6d5"]])

export default __exports__